import React, { useState, useEffect, useRef } from "react";
import { Button, Col, Row, Modal, Form, Table } from "react-bootstrap";
import ExportApi from "../api/ExportApi";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { useAuthUser } from "../customHooks/useAuthUser";
import ReactPaginate from "react-paginate";
import SharedTable from "../shared/sharedTable";
import { PRODUCT_TYPES } from "../helper/constant";
import QuestionMarkSvg from "../assets/svg/QuestionMarkSvg";
import { getExpDate, getRemainingDays } from "../helper/utils";
import EditSvg from "../assets/svg/editSvg";
import SharedOffcanvas from "../shared/sharedOffcanvas";
import CustomModal from "../shared/CustomModal";

export default function SellingTab() {
  const loggedInUser = useAuthUser();
  let imageUrl = process.env.REACT_APP_IMAGEBASEURL;
  const navigate = useNavigate();
  const [askList, setAskList] = useState([]);
  const [allAskList, setAllAskList] = useState([]);
  const [allAskList1, setAllAskList1] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [loading, setLoading] = useState(0);
  const [conditionKey, setconditionKey] = useState([]);
  const [chipsetKey, setchipsetKey] = useState([]);
  const [brandKey, setbrandKey] = useState([]);
  const [seriesKey, setseriesKey] = useState([]);
  const [modalKey, setmodalKey] = useState([]);
  const [FilterList, setFilterList] = useState();
  const [chipsetShow, setChipsetShow] = useState(false);
  const [seriesShow, setSeriesShow] = useState(false);
  const [modelShow, setModelShow] = useState(false);
  const [condition1, setcondition1] = useState([]);
  const [brandShow, setBrandShow] = useState(false);
  const [chipset, setchipset] = useState([]);
  const [condition, setcondition] = useState([]);
  const [brand, setbrand] = useState([]);
  const [series, setseries] = useState([]);
  const [model, setmodel] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [selectCheckBox, setSelectCheckBox] = useState(false);
  const [descriptionindex, setdescriptionindex] = useState();
  const [descriptionindex1, setdescriptionindex1] = useState();
  const [asklistStatus, setAskListStatus] = useState(false);
  const [currentSortKey, setCurrentSortKey] = useState(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);

  const [selectedRow, setSelectedRow] = useState(null);
  const [graphData, setGraphData] = useState();
  const [hide, setHide] = useState(false);
  const [ID, setID] = useState();
  const containerRef = useRef(null);
  const modalRef = useRef(null);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  const [updateAsk, setUpdateAsk] = useState(null);
  const [allLoaders , setAllLoaders] = useState({
    makeActive : false,
    makeInactive : false,
})

    const columns = [
      {
        name: () => {
          return (
            <span onClick={(e) => e.stopPropagation()} className="d-flex flex-row gap-1">
              <Form.Check>
                <Form.Check.Input
                  type="checkbox"
                  checked={
                    askList?.length > 0 &&
                    selectedData.length === askList?.length
                  }
                  onChange={handleSelectAll}
                  style={{ cursor: "pointer" }}
                />
                <Form.Check.Label style={{ cursor: "pointer" }}>
                  Select All
                </Form.Check.Label>
              </Form.Check>
            </span>
          )
        },
        render: (row) => {
          return (
            <div onClick={(e) => e.stopPropagation()} style={{ cursor: "pointer" }}>
              <Form.Check className="d-inline">
                <Form.Check.Input
                  type="checkbox"
                  checked={selectedData.includes(row?._id)}
                  onChange={(e) =>
                    handleCheck(e.target.checked, row?._id)
                  }
                  style={{ cursor: "pointer" }}   // 👈 fixes the box
                />
              </Form.Check>
            </div>
          )
        }
      },
      {
        name: "Created Date",
        render: (row) => {
          const localDateStr = row.createdAt
            ? moment(row.createdAt).local().format("DD/MM/YY")
            : "-";
  
          return <div>{localDateStr}</div>;
        },
      },
      {
        name: "Product",
        render: (row) => {
          return (
            <div className="d-flex flex-row justify-content-center align-items-center">
              <div style={{ width: "50px", height: "50px" }}>
                <img
                  src={
                    row?.productId?.image[0]?.startsWith("http")
                      ? row?.productId?.image[0]
                      : `${imageUrl}${row?.productId?.image[0]}`
                  }
                  style={{ width: "100%", height: "100%" }}
                  onClick={() =>
                    navigate(
                      `/product/${row?.productId?.slug}`
                    )
                  }
                />
              </div>
              <div class="position-relative ms-1">
                <span className="d-block text-center">
                  {PRODUCT_TYPES[row?.productId?.type]}
                </span>
              </div>
            </div>
          )
        }
      },
      {
        name: "Chipset",
        render: (row) => {
          return (
            <div>  {row?.productId?.chipset}</div>
          )
        }
      },
      {
        name: "Expiration(Remaining days)",
        width: "150px",
        render: (row) => {
          return (
            <div style={{ width: "30px" }}>
              <span>
                {getRemainingDays(row?.createdAt, row?.expirationTime)}
              </span>
            </div>
          )
        }
      },
      {
        name: "Expiration Date",
        width: "100px",
        render: (row) => {
          return (
            <div style={{ width: "30px" }}>
              <span>
                {getExpDate(row?.createdAt, row?.expirationTime)}
              </span>
            </div>
          )
        }
      },
      {
        name: "Ask Status",
        width: "100px",
        render: (row) => {
          return (
            <div style={{ width: "30px" }}>
              {
                getRemainingDays(row?.createdAt, row?.expirationTime) <= 0 ? (
                  <span className="text-danger">
                    Expired
                  </span>
                ) : row?.askStatus ? (
                  <span className="text-success">
                    Active
                  </span>
                ) : (
                    <span className="text-warning">
                    Inactive
                  </span>
                )
              }
  
            </div>
          )
        }
      },
      {
        name: () => {
          return (
            <span className="d-flex flex-row gap-1 align-items-center">
              <span>
                Spread
              </span>
              <ReactTooltip
                className="custom-tooltip"
                anchorId={`app-batch-spread-tab`}
                place="bottom"
                clickable={true}
                closeOnScroll={false}
                content={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: "<p>Spread = Lowest Ask - Your Bid</p>",
                    }}
                  />
                }
              />
              <span style={{ cursor: "pointer" }}>
                <QuestionMarkSvg id={`app-batch-spread-tab`} />
              </span>
            </span>
          )
        },
        render: (row) => {
          return (
            <div>
              {Number(row?.productId?.highest_bid) -
                Number(row?.askAmount)}
            </div>
          )
        }
      },
      {
        name: "Highest Bid",
        render: (row) => {
          return (
            <div>
              <button
                onClick={(e) => {
                  e.stopPropagation()
                  window.open(`/bidask/${row?.productId?.slug}`, "_blank")
                }
                }
                className="btn btn-success p-2 border border-dark"
                style={{ backgroundColor: "#990000", borderRadius: "50px", padding: "6px 16px" }}
              >
                {row?.productId?.highest_bid && row?.productId?.highest_bid > 0
                  ? "Sell Now - $" + row?.productId?.highest_bid
                  : "Not Found"}
              </button> </div>
          )
        }
      },
      {
        name: "Your Ask",
        render: (row) => {
          return (
            <div>  {row?.askAmount && row?.askAmount > 0 ? row?.askAmount : "NA"}</div>
          )
        }
      },
      {
        name: "Actions",
        render: (row) => {
          return (
            <div onClick={(e) => e.stopPropagation()}>
              <span
               onClick={() => setUpdateAsk(row)}
               >
                <EditSvg />
              </span>
            </div>
          )
        }
      }
    ]


  const updateAskData = (id, exp) => {
    setLoading(0);
    ExportApi.updateExpirationAndQuantity(id, exp)
      .then((resp) => {
        if (resp.status == 201) {
          HandleGetAskList(JSON.parse(localStorage.getItem("tokenuser")).id);
          setSelectedRow(null);
          setUpdateAsk(null);
        } else {
          setLoading(2);
          setUpdateAsk(null);
        }
      })
      .catch((err) => {
        console.log(err);
        setUpdateAsk(null);
      });
  };

  // Function to get the data of the ask list based on the provided ID
  const HandleGetAskList = (id) => {
    ExportApi.askList(id)
      .then((resp) => {
        if (resp.data.message == "Ask list found") {
          setAllAskList(resp.data.data);
          setAllAskList1(resp.data.data);

          if (!asklistStatus) {
            // Button is selected, apply filter and store previousAskList
            let result = resp.data.data?.filter(
              (item) => item.askStatus === true
            );

            setAskList(result);
          } else {
            let result = resp.data.data?.filter(
              (item) => item.askStatus === false
            );

            setAskList(result);
          }
          setSelectCheckBox(false);
          setLoading(1);
        } else {
          setLoading(2);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Function for handling the "Select All" functionality for multiple checkboxes
  //e used for the check checkbox is select or not
  const handleSelectAll = (e) => {
    const checked = e.target.checked;

    if (checked) {
      const allIds = askList?.map((item) => item._id);
      setSelectedData(allIds);
    } else {
      setSelectedData([]);
    }
  };

  // Function to handle individual checkbox selection
  //data used for the check checkbox is selected or not
  //id used for the which checkbox is selected
  const handleCheck = (checked, id) => {
    setSelectedData((prev) => {
      if (checked) {
        // add id
        return [...prev, id];
      } else {
        // remove id
        return prev.filter((itemId) => itemId !== id);
      }
    });
  };

  // Pagination handlers
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  // Calculate paginated data
  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = askList?.slice(indexOfFirstItem, indexOfLastItem) || [];
  const pageCount = Math.ceil((askList?.length || 0) / itemsPerPage);

  // Function to filter data based on various criteria
  const SearchFilterCheck = () => {
    let filterData = askList;
    let filteredList = filterData; // Start with the original list
    if (
      condition?.length > 0 ||
      brand?.length > 0 ||
      series?.length > 0 ||
      model?.length > 0 ||
      chipset?.length > 0
    ) {
      if (condition?.length > 0) {
        // Filter by condition
        filteredList = filteredList?.filter((item) =>
          condition.includes(item?.productId.type)
        );
      }
      if (brand?.length > 0) {
        // Filter by brand
        filteredList = filteredList?.filter((item) =>
          brand.includes(item?.productId?.brand)
        );
      }
      if (series?.length > 0) {
        // Filter by series
        filteredList = filteredList?.filter((item) =>
          series.includes(item?.productId?.series)
        );
      }
      if (model?.length > 0) {
        // Filter by model
        filteredList = filteredList?.filter((item) =>
          model.includes(item?.productId?.model)
        );
      }
      if (chipset?.length > 0) {
        // Filter by chipset
        filteredList = filteredList?.filter((item) =>
          chipset.includes(item?.productId?.chipset)
        );
      }
      setAskList(filteredList);
      setCurrentPage(0); // Reset to first page when filter changes
    } else {
      if (localStorage.getItem("tokenuser")) {
        HandleGetAskList(JSON.parse(localStorage.getItem("tokenuser")).id);
        HandleGetFilterListData();
      } else if (localStorage.getItem("admin")) {
        HandleGetAskList(JSON.parse(localStorage.getItem("admin")).id);
        HandleGetFilterListData();
      } else {
        // Handle the case when no filters are applied
      }
      setCurrentPage(0); // Reset to first page when filter changes
    }
  };

  // Function to get filter data
  const HandleGetFilterListData = () => {
    // Fetch filter-related data from an API
    ExportApi.GetFilterData()
      .then((resp) => {
        // Initialize arrays to hold filter-related data
        let chipsetKeyArray = [];
        let conditionKeyArray = [];
        let brandKeyArray = [];
        let modalKeyArray = [];
        let seriesKeyArray = [];

        // Process and prepare data for various filter options
        resp?.data.data?.chipset?.map((val, i) => {
          let key = { [val]: false };
          chipsetKeyArray.push(key);
        });
        setchipsetKey([...chipsetKeyArray]);

        resp?.data.data?.condition?.map((val) => {
          if (val == 1) {
            let key = { ["New-Retail"]: false };
            conditionKeyArray.push(key);
          } else if (val == 2) {
            let key = { ["New-2nd Hand"]: false };
            conditionKeyArray.push(key);
          } else {
            let key = { ["Used"]: false };
            conditionKeyArray.push(key);
          }
        });
        setconditionKey([...conditionKeyArray]);

        resp?.data.data?.series?.map((val) => {
          let key = { [val]: false };
          seriesKeyArray.push(key);
        });
        setseriesKey([...seriesKeyArray]);

        resp?.data.data?.brands?.map((val) => {
          let key = { [val]: false };
          brandKeyArray.push(key);
        });
        setbrandKey([...brandKeyArray]);

        resp?.data.data?.model?.map((val) => {
          let key = { [val]: false };
          modalKeyArray.push(key);
        });
        setmodalKey([...modalKeyArray]);

        // Set the filter-related data in the component's state
        setFilterList(resp?.data?.data);
      })
      .catch((err) => console.log(err));
  };

  // Function to open the filter modal
  const handleFilter = () => {
    setShowFilterModal(true);
  };

  const filterData = () => {
    SearchFilterCheck();
  };

  // Function to clear all applied filters
  const clearAllFilters = () => {
    setSelectCheckBox(false);
    setmodel([]);
    setseries([]);
    setbrand([]);
    setchipset([]);
    setcondition([]);
    setcondition1([]);
    if (localStorage.getItem("tokenuser")) {
      HandleGetAskList(JSON.parse(localStorage.getItem("tokenuser")).id);
      HandleGetFilterListData();
    } else if (localStorage.getItem("admin")) {
      HandleGetAskList(JSON.parse(localStorage.getItem("admin")).id);
      HandleGetFilterListData();
    } else {
    }
  };

  // Function to close a specific condition filter
  //i used for the indexing
  //name used for the which condition filter is implemented
  const conditionKeyFilterClose = (i, name) => {
    setSelectCheckBox(false);

    // Find the index of the condition filter to be closed
    let index = -1;
    for (let i = 0; i < conditionKey.length; i++) {
      if (Object.keys(conditionKey[i])[0] == name) {
        index = i;
      }
    }

    // Remove the condition filter from the arrays and update the UI
    conditionKey[index][name] = false;
    condition1.splice(i, 1);
    condition.splice(i, 1);

    setcondition1([...condition1]);
    setcondition([...condition]);

    // Trigger the filter check function
    setTimeout(() => {
      SearchFilterCheck();
    });
  };

  // Function to close a specific chipset filter
  //id used for the indexing
  //name used for the which condition filter is implemented
  const ChipsetFilterClose = (id, name) => {
    setSelectCheckBox(false);

    // Find the index of the chipset filter to be closed
    let index = -1;
    for (let i = 0; i < chipsetKey.length; i++) {
      if (Object.keys(chipsetKey[i])[0] == name) {
        index = i;
      }
    }

    // Remove the chipset filter from the array and update the UI
    chipsetKey[index][name] = false;
    chipset.splice(id, 1);

    setchipset([...chipset]);

    // Trigger the filter check function
    setTimeout(() => {
      SearchFilterCheck();
    });
  };

  // Function to close a specific brand filter
  //i used for the indexing
  //name used for the which brand filter is implemented
  const brandFilterClose = (i, name) => {
    setSelectCheckBox(false);

    // Find the index of the brand filter to be closed
    let index = -1;
    for (let i = 0; i < brandKey.length; i++) {
      if (Object.keys(brandKey[i])[0] == name) {
        index = i;
      }
    }

    // Remove the brand filter from the array and update the UI
    brandKey[index][name] = false;
    brand.splice(i, 1);

    setbrand([...brand]);

    // Trigger the filter check function
    setTimeout(() => {
      SearchFilterCheck();
    });
  };

  // Function to close a specific series filter
  //i used for the indexing
  //name used for the which series filter is implemented
  const seriesFilterClose = (i, name) => {
    setSelectCheckBox(false);

    // Find the index of the series filter to be closed
    let index = -1;
    for (let i = 0; i < seriesKey.length; i++) {
      if (Object.keys(seriesKey[i])[0] == name) {
        index = i;
      }
    }

    // Remove the series filter from the array and update the UI
    seriesKey[index][name] = false;
    series.splice(i, 1);

    setseries([...series]);

    // Trigger the filter check function
    setTimeout(() => {
      SearchFilterCheck();
    });
  };

  // Function to close a specific modal filter
  //i used for the indexing
  //name used for the which modal filter is implemented
  const modalFilterClose = (i, name) => {
    setSelectCheckBox(false);

    // Find the index of the modal filter to be closed
    let index = -1;
    for (let i = 0; i < modalKey.length; i++) {
      if (Object.keys(modalKey[i])[0] == name) {
        index = i;
      }
    }

    // Remove the modal filter from the array and update the UI
    modalKey[index][name] = false;
    model.splice(i, 1);

    setmodel([...model]);

    // Trigger the filter check function
    setTimeout(() => {
      SearchFilterCheck();
    });
  };

  // Function to handle the chipset filter
  //i used for the indexing
  //name used for the which chipset filter is implemented
  const ChipsetFilter = (e, i) => {
    setSelectCheckBox(false);
    const { name, checked } = e.target;
    let index = chipset.indexOf(name);

    if (checked || index === -1) {
      // If checked or not found in the array, add it to the chipset filter
      chipset.push(name);
      chipsetKey[i][name] = checked;

      setchipset([...chipset]);
      filterData();

      // Trigger the filter check function
      // setTimeout(() => {
      //   SearchFilterCheck();
      // });
    } else {
      // If unchecked, remove it from the chipset filter
      chipsetKey[i][name] = checked;
      chipset.splice(index, 1);

      setchipset([...chipset]);
      filterData();

      // Trigger the filter check function
      // setTimeout(() => {
      //   SearchFilterCheck();
      // });
    }
  };
  // Function to handle the condition filter
  //i used for the indexing
  //name used for the which condition filter is implemented
  const conditionKeyFilter = (e, i) => {
    setSelectCheckBox(false);

    const { name, checked, min } = e.target;
    let number = parseInt(min);
    let index = condition.indexOf(number);
    let index1 = condition1.indexOf(name);

    if (checked || index === -1 || index1 === -1) {
      // If checked or not found in the array, add it to the condition filter
      condition.push(number);
      condition1.push(name);
      conditionKey[i][name] = checked;

      setcondition([...condition]);
      setcondition1([...condition1]);
      filterData();
      // Trigger the filter check function
      // setTimeout(() => {
      //   SearchFilterCheck();
      // });
    } else {
      // If unchecked, remove it from the condition filter
      conditionKey[i][name] = checked;
      condition.splice(index, 1);
      condition1.splice(index1, 1);

      setcondition([...condition]);
      setcondition1([...condition1]);
      filterData();

      // Trigger the filter check function
      // setTimeout(() => {
      //   SearchFilterCheck();
      // });
    }
  };

  // Function to handle the modal filter
  //i used for the indexing
  //name used for the which modal filter is implemented
  const modalFilter = (e, i) => {
    setSelectCheckBox(false);
    const { name, checked } = e.target;
    let index = chipset.indexOf(name);

    if (checked) {
      // If checked, add it to the modal filter
      model.push(name);
      modalKey[i][name] = checked;

      setmodel([...model]);
      filterData();

      // Trigger the filter check function
      // setTimeout(() => {
      //   SearchFilterCheck();
      // });
    } else {
      // If unchecked, remove it from the modal filter
      modalKey[i][name] = checked;
      model.splice(index, 1);

      setmodel([...model]);
      filterData();

      // Trigger the filter check function
      // setTimeout(() => {
      //   SearchFilterCheck();
      // });
    }
  };

  // Function to handle series filter
  //i used for the indexing
  //name used for the which series filter is implemented
  const seriesFilter = (e, i) => {
    setSelectCheckBox(false);
    const { name, checked } = e.target;
    let index = series.indexOf(name);

    if (checked) {
      // If checked, add it to the series filter
      series.push(name);
      seriesKey[i][name] = checked;

      setseries([...series]);
      filterData();

      // Trigger the filter check function
      // setTimeout(() => {
      //   SearchFilterCheck();
      // });
    } else {
      // If unchecked, remove it from the series filter
      seriesKey[i][name] = checked;
      series.splice(index, 1);

      setseries([...series]);
      filterData();

      // Trigger the filter check function
      // setTimeout(() => {
      //   SearchFilterCheck();
      // });
    }
  };
  // Function to handle brand filter
  //i used for the indexing
  //name used for the which brand filter is implemented
  const BrandFilter = (e, i) => {
    setSelectCheckBox(false);
    const { name, checked } = e.target;
    let index = brand.indexOf(name);

    if (checked) {
      // If checked, add it to the brand filter
      brand.push(name);
      brandKey[i][name] = checked;

      setbrand([...brand]);
      filterData();
      // Trigger the filter check function
      // setTimeout(() => {
      //   SearchFilterCheck();
      // });
    } else {
      // If unchecked, remove it from the brand filter
      brandKey[i][name] = checked;
      brand.splice(index, 1);

      setbrand([...brand]);
      filterData();
      // Trigger the filter check function
      // setTimeout(() => {
      //   SearchFilterCheck();
      // });
    }
  };

  //Product Delete
  const handleDeleteProduct = () => {
    if (selectedData?.length > 0) {
      let confirm = window.confirm("Are you sure you want to delete");
      if (confirm) {
        ExportApi.deleteSellingTabProduct(selectedData).then((resp) => {
          if (resp.data) {
            toast.success(resp.data.message);
            HandleGetAskList(JSON.parse(localStorage.getItem("tokenuser")).id);
            // window.location.reload();
          } else {
            toast.error(resp.data.message);
          }
        });
      } else {
      }
    } else {
      toast.error("Please Select a Product First");
    }
  };

  // Function to fetch user data based on user ID for authentication
  //id used for the specific user id
  const handleSingleUserData = (id) => {
    ExportApi.getSingleUserData(id)
      .then((resp) => {
        if (resp.data.message == "user not found") {
          // If the user is not found, dispatch the "Loginout" event
          window.dispatchEvent(new Event("Loginout"));
        } else {
          // Handle the case when user data is found
        }
      })
      .catch((err) => console.log(err));
  };

  // Function to show more or less series results
  //data used for to show less or more data
  const handlemodelshowmore = (data) => {
    if (data == "More") {
      setModelShow(true);
    } else {
      setModelShow(false);
    }
  };
  // Function to show more or less series results
  //data used for to show less or more data
  const handlechipsetshowmore = (data) => {
    if (data == "More") {
      setChipsetShow(true);
    } else {
      setChipsetShow(false);
    }
  };

  //function to show inactive ask
  const handleShowInactiveAskList = () => {
    if (!asklistStatus) {
      // Button is selected, apply filter and store previousAskList
      let result = allAskList?.filter((item) => item.askStatus === false);
      //setPreviousAskList(askList); // Store the previous askList

      setAskList(result);
    } else {
      let result = allAskList?.filter((item) => item.askStatus === true);
      // Button is deselected, restore previousAskList
      // setAskList(previousAskList);
      setAskList(result);
    }
    // Toggle the button status
    setAskListStatus(!asklistStatus);
    setCurrentPage(0); // Reset to first page when status changes
  };

  // Function to show more or less series results
  //data used for to show less or more data
  const handleSeriesshowmore = (data) => {
    if (data == "More") {
      setSeriesShow(true);
    } else {
      setSeriesShow(false);
    }
  };

  // Function to show more or less series results
  //data used for to show less or more data
  const handlebrandshowmore = (data) => {
    if (data == "More") {
      setBrandShow(true);
    } else {
      setBrandShow(false);
    }
  };

  // Adding an event listener to the 'window' object for the "Loginout" event
  window.addEventListener("Loginout", () => {
    // This code block is executed when the "Loginout" event is triggered

    // Clear the localStorage (removes user/admin tokens)
    localStorage.clear();

    // Navigate to the root path ("/")
    navigate("/");
  });

  useEffect(() => {
    if (localStorage.getItem("tokenuser")) {
      HandleGetAskList(JSON.parse(localStorage.getItem("tokenuser")).id);
      HandleGetFilterListData();
      handleSingleUserData(JSON.parse(localStorage.getItem("tokenuser")).id);
    } else if (localStorage.getItem("admin")) {
      HandleGetAskList(JSON.parse(localStorage.getItem("admin")).id);
      HandleGetFilterListData();
      handleSingleUserData(JSON.parse(localStorage.getItem("admin")).id);
    } else {
    }
  }, []);

  useEffect(() => {
    const handleMobileFunction = (e) => {
      const { action } = e.detail;
      if (action === 'delete') handleDeleteProduct();
      if (action === 'makeActive') updateAsksStatus(selectedData, true);
      if (action === 'makeInactive') updateAsksStatus(selectedData, false);
      if (action === 'showInactive') handleShowInactiveAskList();
      if (action === 'filter') handleFilter();
    };

    window.addEventListener('mobileFunction', handleMobileFunction);
    return () => window.removeEventListener('mobileFunction', handleMobileFunction);
  }, [selectedData]);

  const updateAsksStatus = (selectData, status) => {
    if (status) {
      setAllLoaders((prev) => ({ ...prev, makeActive: true }))
    }
    else {
      setAllLoaders((prev) => ({ ...prev, makeInactive: true }))
    }
   
    if (selectedData.length > 0) {
      ExportApi.updateAskList(selectData, status, loggedInUser?.id)
        .then((resp) => {
          setAllLoaders((prev) => ({ ...prev, makeActive: false, makeInactive : false}))
          if (resp?.data?.status == true) {
            HandleGetAskList(loggedInUser?.id);
            setSelectedData([]);
          }
          else {
            toast.error(resp?.data?.message);
            setSelectedData([]);
          }

        })
        .catch((err) => {
          setAllLoaders((prev) => ({ ...prev, makeActive: false, makeInactive : false}))
          console.log(err);
        });
    } else {
      toast.error("Please Select a Product First");
    }
  };

  const duplicateAskList = (selectData, status) => {
    if (selectedData.length > 0) {
      const resultArray = askList.filter((item) =>
        selectedData.includes(item._id)
      );

      ExportApi.duplicateBidsAsks(resultArray, "ask")
        .then((resp) => {
          HandleGetAskList(JSON.parse(localStorage.getItem("tokenuser"))?.id);
          // setTimeout(() => {
          //   handleShowInactiveAskList()
          // }, 1000);

          // if (resp.data.message == "Ask list found") {
          //   setAllAskList(resp.data.data);
          //   let result = resp.data.data?.filter((item) => item.askStatus === true);
          //   setAskList(result);
          //   setLoading(1);
          // } else {
          //   setLoading(2);
          // }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toast.error("Please Select a Product First");
    }
    return;
  };

  //sort data Here
  //key used for the get the name of the variable for sorting
  const sortHere = (key) => {
    if (!askList || askList.length === 0) return;

    const sortOrder = key === currentSortKey ? -currentSortOrder : 1;
    // Create a new array to avoid mutating the original
    const sortedProducts = [...askList].sort((a, b) => {
      const aVal = a[key];
      const bVal = b[key];

      // Handle null/undefined values
      if (aVal == null && bVal == null) return 0;
      if (aVal == null) return 1 * sortOrder;
      if (bVal == null) return -1 * sortOrder;

      // Handle numeric values
      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return (aVal - bVal) * sortOrder;
      }

      // Handle string values
      if (aVal < bVal) return -1 * sortOrder;
      if (aVal > bVal) return sortOrder;
      return 0;
    });

    setAskList(sortedProducts);
    setCurrentSortKey(key);
    setCurrentSortOrder(sortOrder);
  };

  const sortProductData = (key) => {
    if (!askList || askList.length === 0) return;

    const sortOrder = key === currentSortKey ? -currentSortOrder : 1;
    // Create a new array to avoid mutating the original
    const sortedProducts = [...askList].sort((a, b) => {
      if (key == "spread") {
        const aSpread = (a?.productId?.["lowest_ask"] || 0) - (a?.productId?.["highest_bid"] || 0);
        const bSpread = (b?.productId?.["lowest_ask"] || 0) - (b?.productId?.["highest_bid"] || 0);

        if (aSpread < bSpread) return -1 * sortOrder;
        if (aSpread > bSpread) return sortOrder;
        return 0;
      } else {
        const aVal = a?.productId?.[key];
        const bVal = b?.productId?.[key];

        // Handle null/undefined values
        if (aVal == null && bVal == null) return 0;
        if (aVal == null) return 1 * sortOrder;
        if (bVal == null) return -1 * sortOrder;

        // Handle numeric values
        if (typeof aVal === 'number' && typeof bVal === 'number') {
          return (aVal - bVal) * sortOrder;
        }

        // Handle string values
        if (aVal < bVal) return -1 * sortOrder;
        if (aVal > bVal) return sortOrder;
        return 0;
      }
    });

    setAskList(sortedProducts);
    setCurrentSortKey(key);
    setCurrentSortOrder(sortOrder);
  };

  const [askListOrderBook, setAskListOrderBook] = useState();
  const [bidListOrderBook, setBidListOrderBook] = useState();

  const showOrderBook = (product_id) => {
    ExportApi.showOrderBook(product_id)
      .then((resp) => {
        if (resp?.data.statusCode == 200) {
          setAskListOrderBook(resp?.data.data.askList);
          setBidListOrderBook(resp?.data.data.bidList);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      const id = ID?.id;
      if (id) {
        try {
          const resp = await ExportApi.getGraphData(id);

          setGraphData(resp);
        } catch (error) {
          console.log(error, "error");
        }
      }
    };

    fetchData();
  }, [ID?.id]);

  useEffect(() => {
    const handleScroll = () => {
      const container = containerRef.current;

      if (container) {
        // Adjust styles based on scroll position
        const scrollTop = container.scrollTop;
        if (scrollTop > 100) {
          container.style.backgroundColor = "lightblue";
        } else {
          container.style.backgroundColor = "transparent";
        }
      }
    };

    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      const container = containerRef.current;
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setHide(false);
    }
  };

  useEffect(() => {
    if (hide) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [hide]);

  // const handleButtonClick = (val, i) => {
  //   setID(val?.productId?._id);
  //   setAskListOrderBook();
  //   setBidListOrderBook();
  //   setdescriptionindex1(descriptionindex1 === i ? null : i);
  //   setHide(!hide);
  // };

  const handleButtonClick = (val, i) => {
    setID({ id: val?.productId?._id, index: i });
    setAskListOrderBook();
    setBidListOrderBook();
    setdescriptionindex1(descriptionindex1 === i ? null : i);
    setSelectedProductId(val?.productId?._id);
    setHide(!hide);
  };

  const handleClickOutsideModal = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setdescriptionindex(null);
    }
  };

  useEffect(() => {
    if (descriptionindex !== null) {
      document.addEventListener("mousedown", handleClickOutsideModal);
    } else {
      document.removeEventListener("mousedown", handleClickOutsideModal);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideModal);
    };
  }, [descriptionindex]);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div>
       <style>
        {
          `
          .form-check-input {
          background-color : none !important;
          }

           .form-check-input:checked {
          background-color : #0d6efd !important;
          }
          `
        }
      </style>
      <Row>
        <Col lg={12} className="mt-sm-3 mt-1" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
          {/* Desktop Function Buttons - Show only on desktop */}
          {isDesktop && (
            <div className="desktop-function-buttons">
              <Button
                className="bg-white text-black border border-2"
                onClick={handleDeleteProduct}
              >
                Delete
              </Button>
              <Button
                className="bg-white text-black border border-2"
                onClick={() => updateAsksStatus(selectedData, true)}
                disabled={!asklistStatus || allLoaders.makeActive}
              >
                {allLoaders.makeActive ? "Please wait..." : "Make Active"}
              </Button>
              <Button
                className="bg-white text-black border border-2"
                onClick={() => updateAsksStatus(selectedData, false)}
                disabled={asklistStatus || allLoaders.makeInactive}
              >
                {allLoaders.makeInactive ? "Please wait..." : "Make Inactive"}
                
              </Button>
              <Button
                className={asklistStatus ? "bg-success text-white border border-2" : "bg-white text-black border border-2"}
                onClick={() => handleShowInactiveAskList()}
              >
                Show Inactive
              </Button>
              <Button
                className="bg-white text-black border border-2"
                onClick={handleFilter}
              >
                Filter
              </Button>
            </div>
          )}

          {/*Start Clear All Filters */}
          <div className="text-center text-sm-start">
            {((condition && condition.length > 0) ||
              (chipset && chipset.length > 0) ||
              (brand && brand.length > 0) ||
              (series && series.length > 0) ||
              (model && model.length > 0)) && (
                <>
                  <Button
                    className="clear-all-filters-btn bg-white border text-dark px-4 py-2 fw-bold"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      clearAllFilters();
                    }}
                    onTouchEnd={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      clearAllFilters();
                    }}
                    style={{
                      cursor: 'pointer',
                      userSelect: 'none',
                      WebkitUserSelect: 'none',
                      touchAction: 'manipulation',
                      minHeight: '38px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    Clear all filters
                  </Button>
                  <div className="filter-chips-grid">
                    {conditionKey.map((val, i) => {
                      let key = condition1[i];
                      let data = conditionKey.filter((item) => item[key] == true);
                      return (
                        data.length != 0 ? (
                          <span
                            key={`condition-${i}`}
                            className="filter-chip-item"
                          >
                            {condition1[i]}{" "}
                            <Button
                              className="filter-chip-close"
                              onClick={() =>
                                conditionKeyFilterClose(i, condition1[i])
                              }
                            >
                              X
                            </Button>
                          </span>
                        ) : null
                      );
                    })}
                    {chipsetKey.map((val, i) => {
                      let key = chipset[i];
                      let data = chipsetKey.filter((item) => item[key] == true);
                      return (
                        data.length != 0 ? (
                          <span
                            key={`chipset-${i}`}
                            className="filter-chip-item"
                          >
                            {chipset[i]}
                            <Button
                              className="filter-chip-close"
                              onClick={() => ChipsetFilterClose(i, chipset[i])}
                            >
                              X
                            </Button>
                          </span>
                        ) : null
                      );
                    })}
                    {brandKey?.map((val, i) => {
                      let key = brand[i];
                      let data = brandKey.filter((item) => item[key] == true);
                      return (
                        data.length != 0 ? (
                          <span
                            key={`brand-${i}`}
                            className="filter-chip-item"
                          >
                            {brand[i]}{" "}
                            <Button
                              className="filter-chip-close"
                              onClick={() => brandFilterClose(i, brand[i])}
                            >
                              X
                            </Button>
                          </span>
                        ) : null
                      );
                    })}
                    {seriesKey.map((val, i) => {
                      let key = series[i];
                      let data = seriesKey.filter((item) => item[key] == true);
                      return (
                        data.length != 0 ? (
                          <span
                            key={`series-${i}`}
                            className="filter-chip-item"
                          >
                            {series[i]}{" "}
                            <Button
                              className="filter-chip-close"
                              onClick={() => seriesFilterClose(i, series[i])}
                            >
                              X
                            </Button>
                          </span>
                        ) : null
                      );
                    })}
                    {modalKey.map((val, i) => {
                      let key = model[i];
                      let data = modalKey.filter((item) => item[key] == true);
                      return (
                        data.length != 0 ? (
                          <span
                            key={`model-${i}`}
                            className="filter-chip-item"
                          >
                            {model[i]}{" "}
                            <Button
                              className="filter-chip-close"
                              onClick={() => modalFilterClose(i, model[i])}
                            >
                              X
                            </Button>
                          </span>
                        ) : null
                      );
                    })}
                  </div>
                </>
              )}
          </div>
          {/* End Clear All Filter  */}
        </Col>

        {/* Start Table Component */}
        <Col lg={12} className="mt-sm-5 mt-3">
          {/* <AccountManagementTable
            Data={askList}
            Data2={loading}
            handleSelectAll={handleSelectAll}
            handleCheck={handleCheck}
            selectCheckBox={selectCheckBox}
          /> */}

          <SharedTable
            // loader={initialLoader}
            columns={columns}
            data={askList}
            onRowClick={(row) => {
              setSelectedRowData(row);
            }}
            // batch={true}
            // batchData={batchData}
            // hideBatchStatus={hideBatchStatus}
            // isDesktop={isDesktop}
          />
          
          {/* Pagination */}
          {/* {askList?.length > itemsPerPage && (
            <div className="d-flex justify-content-center mt-4 mb-4">
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                forcePage={currentPage}
              />
            </div>
          )} */}
          <br></br>
        </Col>
      </Row>

      {/* Start Filter Modal */}
      <Modal
        className="custom-mode"
        contentClassName="custom-modal-content"
        show={showFilterModal}
        backdrop={true}
        onHide={() => setShowFilterModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Product Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body className="scrollable-modal-body">
          <div className="border mb-sm-5">
            <div className="sidebar-accordian p-3">
              <div>
                <span>
                  <b>Condition</b>
                </span>
                {FilterList?.condition?.map((val, i) => {
                  return (
                    <Form.Group className="mb-2" controlId={val} key={i}>
                      <Form.Check
                        type="checkbox"
                        checked={
                          conditionKey[i][
                          val == 1
                            ? "New-Retail"
                            : val == 2
                              ? "New"
                              : "Used"
                          ]
                        }
                        onChange={(e) => conditionKeyFilter(e, i)}
                        name={
                          val == 1
                            ? "New-Retail"
                            : val == 2
                              ? "New"
                              : "Used"
                        }
                        min={val}
                        label={
                          val == 1
                            ? "New-Retail"
                            : val == 2
                              ? "New"
                              : "Used"
                        }
                      />
                    </Form.Group>
                  );
                })}
                {conditionKey?.length > 6 ? (
                  <Button className="bg-none mb-3 border-0 p-0 text-dark">
                    <span className="d-inline me-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-square-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                      </svg>
                    </span>{" "}
                    Show More
                  </Button>
                ) : null}
              </div>

              <div>
                <span>
                  <b>Chipset</b>
                </span>
                {chipsetShow
                  ? FilterList?.chipset?.map((val, i) => {
                    return (
                      <>
                        <Form.Group className="mb-2" controlId={val} key={i}>
                          <Form.Check
                            type="checkbox"
                            checked={chipsetKey[i][val]}
                            onChange={(e) => ChipsetFilter(e, i)}
                            name={val}
                            label={val}
                          />
                        </Form.Group>
                      </>
                    );
                  })
                  : FilterList?.chipset?.map((val, i) => {
                    return (
                      <>
                        {i < 6 ? (
                          <Form.Group
                            className="mb-2"
                            controlId={val}
                            key={i}
                          >
                            <Form.Check
                              type="checkbox"
                              checked={chipsetKey[i][val]}
                              onChange={(e) => ChipsetFilter(e, i)}
                              name={val}
                              label={val}
                            />
                          </Form.Group>
                        ) : null}
                      </>
                    );
                  })}
                {chipsetShow ? (
                  FilterList?.chipset?.length > 6 ? (
                    <Button
                      className="bg-none mb-3 border-0 p-0 text-dark"
                      onClick={() => handlechipsetshowmore("Less")}
                    >
                      <span className="d-inline me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-plus-square-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                        </svg>
                      </span>{" "}
                      Show Less
                    </Button>
                  ) : null
                ) : FilterList?.chipset?.length > 6 ? (
                  <Button
                    className="bg-none mb-3 border-0 p-0 text-dark"
                    onClick={() => handlechipsetshowmore("More")}
                  >
                    <span className="d-inline me-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-square-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                      </svg>
                    </span>{" "}
                    Show More
                  </Button>
                ) : null}
              </div>

              <div>
                <span>
                  <b>Brand</b>
                </span>
                {brandShow
                  ? FilterList?.brands?.map((val, i) => {
                    return (
                      <>
                        <Form.Group className="mb-2" controlId={val} key={i}>
                          <Form.Check
                            type="checkbox"
                            checked={brandKey[i][val]}
                            onChange={(e) => BrandFilter(e, i)}
                            name={val}
                            label={val}
                          />
                        </Form.Group>
                      </>
                    );
                  })
                  : FilterList?.brands?.map((val, i) => {
                    return (
                      <>
                        {i < 6 ? (
                          <Form.Group
                            className="mb-2"
                            controlId={val}
                            key={i}
                          >
                            <Form.Check
                              type="checkbox"
                              checked={brandKey[i][val]}
                              onChange={(e) => BrandFilter(e, i)}
                              name={val}
                              label={val}
                            />
                          </Form.Group>
                        ) : null}
                      </>
                    );
                  })}
                {brandShow ? (
                  FilterList?.brands?.length > 6 ? (
                    <Button
                      className="bg-none mb-3 border-0 p-0 text-dark"
                      onClick={() => handlebrandshowmore("Less")}
                    >
                      <span className="d-inline me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-plus-square-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1" />
                        </svg>
                      </span>{" "}
                      Show Less
                    </Button>
                  ) : null
                ) : FilterList?.brands?.length > 6 ? (
                  <Button
                    className="bg-none mb-3 border-0 p-0 text-dark"
                    onClick={() => handlebrandshowmore("More")}
                  >
                    <span className="d-inline me-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-square-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                      </svg>
                    </span>{" "}
                    Show More
                  </Button>
                ) : null}
              </div>

              <div>
                <span>
                  <b>Series</b>
                </span>
                {seriesShow ? (
                  <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                    {FilterList?.series?.map((val, i) => {
                      return (
                        <>
                          <Form.Group className="mb-2" controlId={val} key={i}>
                            <Form.Check
                              type="checkbox"
                              checked={seriesKey[i][val]}
                              onChange={(e) => seriesFilter(e, i)}
                              name={val}
                              label={val}
                            />
                          </Form.Group>
                        </>
                      );
                    })}
                  </div>
                ) : (
                  <div>
                    {FilterList?.series?.map((val, i) => {
                      return (
                        <>
                          {i < 6 ? (
                            <Form.Group
                              className="mb-2"
                              controlId={val}
                              key={i}
                            >
                              <Form.Check
                                type="checkbox"
                                checked={seriesKey[i][val]}
                                onChange={(e) => seriesFilter(e, i)}
                                name={val}
                                label={val}
                              />
                            </Form.Group>
                          ) : null}
                        </>
                      );
                    })}
                  </div>
                )}
                {seriesShow ? (
                  FilterList?.series?.length > 10 ? (
                    <Button
                      className="bg-none mb-3 border-0 p-0 text-dark"
                      onClick={() => handleSeriesshowmore("Less")}
                    >
                      <span className="d-inline me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-plus-square-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1" />
                        </svg>
                      </span>{" "}
                      Show Less
                    </Button>
                  ) : null
                ) : FilterList?.series?.length > 3 ? (
                  <Button
                    className="bg-none mb-3 border-0 p-0 text-dark"
                    onClick={() => handleSeriesshowmore("More")}
                  >
                    <span className="d-inline me-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-square-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                      </svg>
                    </span>{" "}
                    Show More
                  </Button>
                ) : null}
              </div>

              <div>
                <span>
                  <b>Model</b>
                </span>
                {modelShow ? (
                  <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                    {FilterList?.model?.map((val, i) => {
                      return (
                        <>
                          <Form.Group className="mb-2" controlId={val} key={i}>
                            <Form.Check
                              type="checkbox"
                              checked={modalKey[i][val]}
                              onChange={(e) => modalFilter(e, i)}
                              name={val}
                              label={val}
                            />
                          </Form.Group>
                        </>
                      );
                    })}
                  </div>
                ) : (
                  <div>
                    {FilterList?.model?.map((val, i) => {
                      return (
                        <>
                          {i < 6 ? (
                            <Form.Group
                              className="mb-2"
                              controlId={val}
                              key={i}
                            >
                              <Form.Check
                                type="checkbox"
                                checked={modalKey[i][val]}
                                onChange={(e) => modalFilter(e, i)}
                                name={val}
                                label={val}
                              />
                            </Form.Group>
                          ) : null}
                        </>
                      );
                    })}
                  </div>
                )}
                {modelShow ? (
                  FilterList?.model?.length > 10 ? (
                    <Button
                      className="bg-none mb-3 border-0 p-0 text-dark"
                      onClick={() => handlemodelshowmore("Less")}
                    >
                      <span className="d-inline me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-plus-square-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1" />
                        </svg>
                      </span>{" "}
                      Show Less
                    </Button>
                  ) : null
                ) : FilterList?.model?.length > 6 ? (
                  <Button
                    className="bg-none mb-3 border-0 p-0 text-dark"
                    onClick={() => handlemodelshowmore("More")}
                  >
                    <span className="d-inline me-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-square-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                      </svg>
                    </span>{" "}
                    Show More
                  </Button>
                ) : null}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <CustomModal
        show={updateAsk !== null}
        handleClose={() => setUpdateAsk(null)}
        headerText="Update Ask"
        actionButtonText="Update"
        closeButtonText="Close"
        actionButton={() =>
          updateAskData(
            updateAsk._id,
            updateAsk?.expirationTime
          )}
          >

        <form>
          <div className="row g-3 align-items-center">
            {/* Bid Amount */}
            <div className="col-12 col-md-6 d-flex align-items-center">
              <label className="form-label mb-0 flex-shrink-0 me-2"><strong>Bid Amount:</strong></label>
              <input
                type="number"
                className="form-control flex-grow-1"
                value={updateAsk?.askAmount || ""}
                disabled
              />
            </div>

            <div className="col-12 col-md-6 d-flex align-items-center">
              <label className="form-label mb-0 flex-shrink-0 me-2"><strong>Expiration Time:</strong></label>
              <select
                className="form-select flex-grow-1"
                value={updateAsk?.expirationTime || ""}
                onChange={(e) => {
                  const newExpirationTime = parseInt(e.target.value);
                  setUpdateAsk((prev) => ({
                    ...prev,
                    expirationTime: newExpirationTime,
                  }));
                }}
                disabled={getRemainingDays(updateAsk?.createdAt, updateAsk?.expirationTime) <= 0 ? true : false}
              >
                <option value="" disabled>Select days</option>
                {Array.from({ length: 30 }, (_, i) => i + 1).map((day) => (
                  <option key={day} value={day}>{day}</option>
                ))}
              </select>
            </div>

            {getRemainingDays(updateAsk?.createdAt, updateAsk?.expirationTime) <= 0 && (
              <small className="text-danger mt-1">
                This Ask has expired. So this can't be updated.
              </small>
            )}
          </div>
        </form>
      </CustomModal>

        <SharedOffcanvas
              show={selectedRowData !== null}
              title={"Product Description"}
              handleClose={() => setSelectedRowData(null)}
              data={selectedRowData}
              forSellingTab={true}
            />
    </div>
  );
}
